export const validatePassword = (password) => {
  // 密码长度检查
  if (password.length <= 8) {
    return '密码长度必须超过 8 位'
  }

  // 正则表达式验证密码复杂度
  const hasUpperCase = /[A-Z]/.test(password)  // 检查大写字母
  const hasLowerCase = /[a-z]/.test(password)  // 检查小写字母
  const hasNumber = /\d/.test(password)        // 检查数字
  const hasSpecialChar = /[!@#$%&*_\-+.,]/.test(password) // 检查特殊字符
  const invalidSpecialChar = /[^A-Za-z0-9!@#$%&*_\-+.,]/.test(password) // 检查无效特殊字符

  // 检查是否包含无效特殊字符
  if (invalidSpecialChar) {
    return '密码只能包含以下特殊字符：!@#$%&*_-+.'
  }

  // 如果任意一项不满足条件，返回相应提示
  if (!hasUpperCase) {
    return '密码必须包含至少一个大写字母'
  }
  if (!hasLowerCase) {
    return '密码必须包含至少一个小写字母'
  }
  if (!hasNumber) {
    return '密码必须包含至少一个数字'
  }
  if (!hasSpecialChar) {
    return '密码必须包含至少一个特殊字符'
  }

  // 如果所有条件都满足
  return 'OK'
}

